import { useState } from "react";
import { Flame } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(
        data.reward_code
          ? `You're in. Use code ${data.reward_code} for 20% off your first order.`
          : "You're on the list. Welcome to the rebellion."
      );
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="border-t border-[#2C2623] bg-[#0C0A09]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Flame className="w-6 h-6 text-[#E05A36]" />
            <span className="font-display font-extrabold text-lg uppercase">
              Popular<span className="text-[#E05A36]">Rebelz</span>
            </span>
          </div>
          <p className="text-sm text-[#7A7067] leading-relaxed max-w-xs">
            Heavyweight streetwear for the rule-breakers. No permission. No apologies.
          </p>
        </div>
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#E05A36] mb-4">Navigate</p>
          <div className="flex flex-col gap-2 text-sm text-[#B8AEA5]">
            <a href="/shop" className="hover:text-[#E05A36] transition-colors w-fit" data-testid="footer-shop-link">Store</a>
            <a href="/#manifesto" className="hover:text-[#E05A36] transition-colors w-fit" data-testid="footer-manifesto-link">Manifesto</a>
            <a href="/admin" className="hover:text-[#E05A36] transition-colors w-fit" data-testid="footer-admin-link">Admin</a>
          </div>
        </div>
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#E05A36] mb-4">Join the rebellion</p>
          <p className="text-sm text-[#7A7067] mb-4">Drops, codes and chaos — straight to your inbox. Get 20% off instantly.</p>
          <form onSubmit={subscribe} className="flex" data-testid="footer-newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-[#171412] border border-[#2C2623] focus:border-[#E05A36] outline-none px-4 py-3 text-sm transition-colors"
              data-testid="footer-newsletter-email-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="bg-[#E05A36] text-[#0C0A09] font-bold uppercase text-xs tracking-wider px-5 hover:bg-[#F06B47] transition-colors disabled:opacity-50"
              data-testid="footer-newsletter-submit-button"
            >
              {loading ? "..." : "Join"}
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-[#2C2623] py-6 text-center text-xs font-mono text-[#7A7067] uppercase tracking-[0.2em]">
        © 2026 Popular Rebelz — No permission needed
      </div>
    </footer>
  );
};
